@let hasProposal = orgChartFeature.selectors.hasProposal.asSignal();

<div class="atn-summit-organization-page">
  <atn-summit-org-chart
    class="atn-summit-organization-page__org-chart"
    orgChartId="current"
  />
  @if (hasProposal) {
    <atn-summit-org-chart
      class="atn-summit-organization-page__org-chart"
      orgChartId="proposed"
    />
  }
</div>
